import getAppSettings from './getAppSettings'

export default {
    getAppSettings,
}
